import React, { useEffect, useState } from "react";
import { Modal } from "../Modal";
import { Form, Input, Space, Typography, App } from "antd";
import { FormattedMessage, useIntl } from "react-intl";
import { useAuth } from "../../contexts/auth";
import { createNotification } from "../../components";
import { deleteWorkspace } from "../../services/workspace/api";
import alertIcon from "../../assets/images/alert.svg";
import errorIcon from "../../assets/images/error.svg";
import successIcon from "../../assets/images/success.svg";
import { useNavigate } from "react-router";

const { Text } = Typography;

export function DeleteWorkspaceModal({ open, onCancel, onSubmit, data }) {
  const intl = useIntl();
  const { message, notification } = App.useApp();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { UpdateWorkspaces, ChangeWorkspace, workspaceId } = useAuth();
  const [submittable, setSubmittable] = useState(false);
  const [status, setStatus] = useState("");

  const values = Form.useWatch([], form);

  useEffect(() => {
    form
      .validateFields({
        validateOnly: true,
      })
      .then(() => setSubmittable(true))
      .catch(() => setSubmittable(false));
  }, [form, values]);


  const submit = async () => {
    await deleteWorkspace(data.value).then((res) => {
      UpdateWorkspaces(res.data.workspaces);
      if (data.value == workspaceId) {
        ChangeWorkspace(res.data.workspaces[0].external_id);
        createNotification("success", intl.formatMessage({ id: "modal.workspace.delete.notification.success" }));
        setTimeout(() => {
          navigate(0);
        }, 400);
      } else {
        setStatus("success");
      }

      form.resetFields();
    }).catch((err) => {
      if (err.status == 403) {
        setStatus("error");
      } else {
        createNotification("error", intl.formatMessage({ id: "modal.workspace.delete.notification.error" }));
      }
    });
  }

  function handleClose() {
      form.resetFields();
      setStatus("");
      onCancel();
  }

  return (
    <Modal.Root visible={open}>
      <Modal.Header
        onCancelAction={handleClose}
        title={intl.formatMessage({ id: "modal.workspace.delete.title" })}
      />
        {!status && data && (
            <>
      <Modal.Content align={"start"}>
        <Modal.Icon>
          <img alt="Alert" src={alertIcon} />
        </Modal.Icon>
        <Space
          direction="vertical"
          size="middle"
          style={{
            display: 'flex',
          }}
        >
          <Form layout="vertical" form={form}>
            <div className="mb-2 grid gap-y-2">
                <p className="text-sm text-gray-700">{intl.formatMessage({id: "modal.workspace.delete.paragraph.1"})}</p>
                <p className="text-sm text-gray-700">{intl.formatMessage({id: "modal.workspace.delete.paragraph.2"})}</p>
                <p className="text-sm text-gray-500">
                    {intl.formatMessage({id: "modal.workspace.delete.paragraph.3"})}  
                    <span className="italic font-semibold"> delete {data.label}</span>
                </p>
            </div>
            <Form.Item
              name="name"
              rules={[
                  () => ({
                    validator(_, value) {
                      if (`delete ${data.label}`.trim() == value) {
                        return Promise.resolve();
                      }
                      return Promise.reject();
                    },
                  }),
              ]}
            >
              <Input
                placeholder={`delete ${data.label}`}
                required
                size="large"
              />
            </Form.Item>
          </Form>
        </Space>
      </Modal.Content>
      <Modal.Actions
        loading={false}
        disabled={!submittable}
        submitText={<FormattedMessage id={"send"} />}
        onSubmitAction={submit}
        onCancelAction={handleClose}
      />
            </>
        )}
      {status == "error" && (
          <>
              <Modal.Content align={"start"}>
                  <Modal.Icon>
                      <img alt="error" src={errorIcon} />
                  </Modal.Icon>
                  <Space direction="vertical">
                  <p className="text-sm text-gray-700">
                    {intl.formatMessage({id: "modal.workspace.delete.error.title"})}
                  </p>
                  <p className="text-sm text-gray-500">
                    {intl.formatMessage({id: "modal.workspace.delete.error.paragraph"})}
                  </p>
                  </Space>
              </Modal.Content>
              <Modal.Actions
                  loading={false}
                  disabled={false}
                  cancelText={intl.formatMessage({id: "close"})}
                  onCancelAction={handleClose}
              />
          </>
      )}
        {status == "success" && (
            <>
                <Modal.Content align={"center"}>
                    <Modal.Icon>
                        <img alt="Success" src={successIcon} />
                    </Modal.Icon>
                    <p className="text-sm text-gray-700">
                      {intl.formatMessage({id: "modal.workspace.delete.success.title"})}
                    </p>
                </Modal.Content>
                <Modal.Actions
                    loading={false}
                    disabled={false}
                    cancelText={intl.formatMessage({ id: "close" })}
                    onCancelAction={handleClose}
                />
            </>
        )}
    </Modal.Root>
  );
}
